import React, { FC, useEffect, useState } from 'react';
import {
  isModalOpenSelector,
  modalActions,
  E2EWrapper,
  basketQuantitySelector,
  basketSelector,
  lastAddedItemsSelector,
  AddedToBasketPreview,
  basketAction,
} from '@elc/common';

import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { BasketWrapper, StyledPopup, BasketQuantity } from './basket.styles';
import { Content } from './content';
import { Header } from './header';
import useCheckoutFlow from '../../hooks/useCheckoutFlow';

type TBasketIconProps = {
  colorRevers?: boolean;
};

export const BASKET_MODAL_ID = 'basket-modal-id';

const Icon = ({ colorRevers }: { colorRevers?: boolean }) => (
  <svg width="17" height="17.68" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 14V8.20782C19 4.22665 16.0964 1.00007 12.5155 1.00007C8.93282 0.982876 6.01547 4.19417 6 8.17534V8.20782V14"
      stroke={colorRevers ? 'black' : 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect y="8.14" width="25" height="17.76" fill={colorRevers ? 'black' : 'white'} />
  </svg>
);

export const BasketIcon: FC<TBasketIconProps> = ({ colorRevers }) => {
  const basketQuantity = useSelector(basketQuantitySelector);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(modalActions.openModal(BASKET_MODAL_ID));
  };
  return (
    <E2EWrapper id="openCartButton">
      <BasketWrapper id="basket-icon" onClick={handleClick} colorRevers={!!colorRevers}>
        <BasketQuantity colorRevers={!!colorRevers} key={basketQuantity}>
          {basketQuantity}
        </BasketQuantity>
        <Icon colorRevers={colorRevers} />
      </BasketWrapper>
    </E2EWrapper>
  );
};

export const Basket = () => {
  const basket = useSelector(basketSelector);
  const basketQuantity = useSelector(basketQuantitySelector);
  const dispatch = useDispatch();
  const isOpen = useSelector(isModalOpenSelector(BASKET_MODAL_ID));
  const [popupPosition, setPopupPosition] = useState({ top: 0, right: 0 });
  const justAddedToBasket = useSelector(lastAddedItemsSelector);
  const linksHidden = useMediaQuery({
    query: `(max-width: 1420px)`,
  });

  useEffect(() => {
    if (isOpen) {
      // @ts-ignore
      const [basketIcon] = [...document.querySelectorAll('#basket-icon')].filter(
        (node) => node.offsetWidth,
      );

      const position = basketIcon?.getBoundingClientRect();

      if (position) {
        const headerOffset = linksHidden ? 0 : 24;
        setPopupPosition({
          top: position.top + position.height + 17 + headerOffset,
          right: window.innerWidth - (position.left || 0) - 35,
        });
      }
    }
  }, [isOpen, linksHidden]);

  const handleCheckoutClick = useCheckoutFlow();

  const closeModal = () => {
    dispatch(modalActions.closeModal());
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <AddedToBasketPreview
        items={justAddedToBasket}
        clearLastAddedItems={() => dispatch(basketAction.clearLastAddedItems())}
        openBasket={() => {
          dispatch(modalActions.openModal(BASKET_MODAL_ID));
        }}
      />
      <StyledPopup
        open={isOpen}
        closeOnDocumentClick
        onClose={closeModal}
        popupPostionTop={popupPosition.top}
        arrowPosition={popupPosition.right}
      >
        <div style={{ height: '100%' }}>
          <Header basketQuantity={basketQuantity} onClose={closeModal} />
          <Content basket={basket} onCheckout={handleCheckoutClick} />
        </div>
      </StyledPopup>
    </div>
  );
};
